
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import './TherapistNotes.scss';
import moment from 'moment';
import { format, parseJSON } from 'date-fns';
import Select from "react-select";
import Box from '@mui/material/Box';
import styled from '@emotion/styled';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import {Button, FormGroup, Label} from "reactstrap";
import Toolbar from '@mui/material/Toolbar';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import { CircularProgress } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableSortLabel from '@mui/material/TableSortLabel';
import Typography from '@mui/material/Typography';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import { rowOptions, downloadExcel, validateDate, stableSort, getComparator} from '../../../utils/Helper'
import { useSelector, useDispatch } from 'react-redux';
import {ReactComponent as DownloadIcon} from "../../../assets/images/CommonComponent/downloads.svg"
import { downloadRecommendationsExcel, getRecommendations, getTherapistList } from '../../../redux/actions/ReportAction/TherapistNotesAction/TherapistNotesAction';
import DatePicker from '../../../components/DatePicker/DatePicker';
import { tabKeys } from '../../../Config/Constant';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))

const headCells = [
    { id: 'name', label: 'Guest Name', sortingKey: 'first_name', disableSorting: true, width: '160px' },
      { id: 'gender', label: 'Gender', sortingKey: 'gender', disableSorting: true, width: '130px' },
      { id: 'room_no', label: 'Guest Room Number', sortingKey: 'room_no', disableSorting: true, width: '230px' },
      { id: 'assign_doctor', label: 'Doctor Name', sortingKey: 'assign_doctor', disableSorting: true, width: '180px' },
      { id: 'support_staff_name', label: 'Therapist Assigned', sortingKey: 'support_staff_name', disableSorting: true, width: '230px' },
      { id: 'session_name', label: 'Session Name', sortingKey: 'session_name', disableSorting: true, width: '200px' },
      { id: 'therapist_room', label: 'Therapy Room Name', sortingKey: 'therapist_room', disableSorting: true, width: '230px' },
      { id: 'session_time', label: 'Session Time', sortingKey: 'session_time', disableSorting: true, width: '200px' },
      { id: 'session_note', label: 'Session Notes', sortingKey: 'session_notes', disableSorting: true, width: '500px' },
      { id: 'notes_recommendation', label: 'Therapist notes', sortingKey: 'notes_recommendation', disableSorting: true, width: '500px' },
    ];
    

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell, index) =>
                (<TableCell
                    key={index}
                    align='left'
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.sortingKey ? order : false}
                    sx={{verticalAlign: 'top', minWidth: headCell.width, maxWidth: headCell.width}}
                >
                    <TableSortLabel
                        active={orderBy === headCell.sortingKey}
                        direction={orderBy === headCell.sortingKey ? order : 'asc'}
                        onClick={createSortHandler(headCell.sortingKey)}
                        hideSortIcon={headCell.sortingKey === 'action' ? true : false}
                    >
                        {headCell.label}
                        {orderBy === headCell.sortingKey ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>)
                )}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['', 'asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { setShowLoader, activeTab } = props;
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    let {downloadLoader, therapistList, loadingTherapistlist} =   useSelector(state => state?.therapistNotesReducer);
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') ||'');
    const [therapistName, setTherapistName] = useState(searchParams.get('therapist_name') ||'');
    const [onDate, setOnDate] = useState(searchParams.get('date_filter')|| moment().format("YYYY-MM-DD"));

    useEffect(() => {
        if (activeTab == tabKeys.reports.THERAPIST_SESSIONS) {
            setSearchText(searchParams.get('filter_text') || '');
            setTherapistName(searchParams.get('therapist_name') || '');
            setOnDate(searchParams.get('date_filter') || moment().format("YYYY-MM-DD"));
        }
    }, [activeTab, searchParams]);

    const handleChangeSearch = (e) => {
        setShowLoader(true);
        const newSearchText = e.target.value;
        setSearchText(newSearchText);
        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, {replace: true});
    }

    const handleChangeTherapist = (e) => {
        setShowLoader(true);
        const newTherapistName = e.value;
        setTherapistName(newTherapistName);
        const newParams = new URLSearchParams(searchParams);
        if (newTherapistName) {
            newParams.set('therapist_name', newTherapistName);
        } else {
            newParams.delete('therapist_name');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, {replace: true});
    }

    const changeonDate = (val) => {
        setShowLoader(true);
        const formattedDate = format(val, "yyyy-MM-dd");
        setOnDate(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate && formattedDate !== moment().format("YYYY-MM-DD")) {
            newParams.set('date_filter', formattedDate);
        } else {
            newParams.delete('date_filter');
        }
        newParams.delete('therapist_name');
        newParams.set('page', '1');
        setTherapistName('');
        
        let sendRequest = {
            "date_filter": searchParams.get('date_filter') || moment().format("YYYY-MM-DD"),
        };
        dispatch(getTherapistList(sendRequest));
        setSearchParams(newParams, {replace: true});
    }

    const downloadTableData = ()=>{
            let d = {}
            const onSuccessCallback = (data)=>{
                downloadExcel({data, fileName: `Therapist Session Report - ${format(new Date(onDate), 'dd-MM-yyyy')}.xlsx`})
              }
    
            dispatch(downloadRecommendationsExcel({
                ...d,
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "searchText": searchParams.get('filter_text') || '',
                "therapist_name": searchParams.get('therapist_name') || '',
                "date_filter": searchParams.get('date_filter') || moment().format("YYYY-MM-DD"),
                "order": searchParams.get('order_by_type') || '',
                "orderBy": searchParams.get('order_by') || '',
                onSuccessCallback
            }))
        }

    return (
        <>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },

            }}
            >
                <div className='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Therapist Sessions
                    </MainHeading>
                </div>

                <div className='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-9 col-xxl-9 d-flex align-items-center LevelDiv'>
                <div className="searchDiv class-search ">
                        <input
                            className="form-control mr-sm-1 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            value={searchText}
                            onChange={handleChangeSearch}
                        ></input>
                    </div>
                    
                    <FormGroup className="FormGroup has-float-label class-menu-dropdown me-2">
                        <Select
                            className="react-select"
                            classNamePrefix="react-select"
                            value={therapistList?.find(item=> item.support_staff_name==therapistName) ? {label: therapistName, value: therapistName} : {label: 'All', value: ""}}
                            options={loadingTherapistlist ? [] : [
                                { label: 'All', value: '' },
                                ...(therapistList
                                  ? therapistList.map(item => ({
                                      label: item.support_staff_name,
                                      value: item.support_staff_name,
                                    }))
                                  : [])
                              ]}   
                            isLoading={loadingTherapistlist}                         
                            onChange={handleChangeTherapist}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: '#F5F5F5',
                                    primary: '#74613C',
                                },
                            })}
                        />
                    </FormGroup>
                    
                    <div className='DurationDiv d-flex align-items-center ms-0'>
                        <DatePicker
                            onChange={date => { changeonDate(date) }}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            value={new Date(onDate)}
                            width={'140px'}
                            height={'48px'}
                        />
                        
                    </div>
                    <div className="separator "></div>

                    {/* <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            value={searchText}
                            onChange={handleChangeSearch}
                        ></input>
                    </div> */}

                    <Button className="btn btn-primary  download-btn " disabled={downloadLoader} type="submit" onClick={downloadTableData}>
                        <span className="btn-icon">
                            {
                                !downloadLoader ?
                                <>
                                    <DownloadIcon fontSize={'17px'} className='mr-1' /> 
                                </>
                                :
                                <CircularProgress size={13} className='mt-1 mr-1' sx={{color: 'white'}} />
                            }
                        </span>
                        Download Excel
                    </Button>
                </div>
            </Toolbar>
            <Divider />
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const TherapistNotes = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order_by_type') ||'');
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') ||'');
    const [selected, setSelected] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const [therapistNotesMainData, settherapistNotesMainData] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const therapistNotes = useSelector(state => state?.therapistNotesReducer);
    const therapistNotesDataRes = useSelector(state => state?.therapistNotesReducer?.recommendations);
    const { activeTab } = props;
    const dispatch = useDispatch();

    useEffect(()=>{
        if(!therapistNotes.loading)
            setShowLoader(false)
        if(!therapistNotes.loading && !therapistNotesDataRes && !therapistNotes.error){
            setShowLoader(true)
        }
    }, [therapistNotes.loading])

    useEffect(() => {
        if (activeTab == tabKeys.reports.THERAPIST_SESSIONS) {
            let sendRequest = {
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "searchText": searchParams.get('filter_text') || '' ,
                "therapist_name": searchParams.get('therapist_name') || '',
                "date_filter": searchParams.get('date_filter') || moment().format("YYYY-MM-DD") ,
                "order": searchParams.get('order_by_type') || '',
                "orderBy": searchParams.get('order_by') || ''
            };
            dispatch(getRecommendations(sendRequest));

            sendRequest = {
                "date_filter": searchParams.get('date_filter') || moment().format("YYYY-MM-DD"),
            };
            if(!therapistNotes?.therapistList){
                dispatch(getTherapistList(sendRequest));
            }
        }else{
          setOrder(searchParams.get('order_by_type') || '');
          setOrderBy(searchParams.get('order_by') || '');
          setRowsPerPage(10)
        }
    }, [activeTab, searchParams]);
    
    useEffect(() => {
        if (therapistNotes.error !== "Ananda program feedback data does not exists") {
            settherapistNotesMainData(therapistNotesDataRes && therapistNotesDataRes?.data);
        } else {
            settherapistNotesMainData('');
        }
    }, [therapistNotesDataRes, therapistNotes])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        if (property) {
            newParams.set('order_by', property);
        } else {
            newParams.delete('order_by');
        }
        newParams.set('order_by_type', newOrder);
        newParams.set('page', '1');
        setSearchParams(newParams, {replace: true});
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = therapistNotesDataRes && therapistNotesMainData.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };


    const handleChangePageNext = () => {
        setShowLoader(true)
        const nextPage = (therapistNotesDataRes?.current_page_no || 0) + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage.toString());
        setSearchParams(newParams, {replace: true});
    };
    
    const handleChangePagePrev = () => {
        setShowLoader(true)
        const prevPage = (therapistNotesDataRes?.current_page_no || 2) - 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage.toString());
        setSearchParams(newParams, {replace: true});
    };

    const handleChangeRowsPerPage = (event) => {
        setShowLoader(true);
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(newRowsPerPage);
        const newParams = new URLSearchParams(searchParams);
        if (newRowsPerPage !== 10) {
            newParams.set('limit', newRowsPerPage.toString());
        } else {
            newParams.delete('limit');
        }
        newParams.set('page', '1');
        setSearchParams(newParams, {replace: true});
    };


    return (
      <Box sx={{ width: '100%' }} className="TherapistNotesBox h-100">
        <Paper className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
              <EnhancedTableToolbar 
                  numSelected={selected.length} 
                  showLoader={showLoader}
                  setShowLoader={setShowLoader}
                  activeTab ={activeTab}
              />
          {
              showLoader ?
              <div className='w-100 text-center py-5'>
                  <CircularProgress sx={{'color': '#74613C'}}/>
              </div>
              :
              <>
                  
                  {therapistNotesMainData && !!therapistNotesMainData?.length ? <TableContainer sx={{ pt: 0, pr: 3, pl: 3, height: '100%' }}>
                      <Table
                          sx={{ minWidth: 750 }}
                          aria-labelledby="tableTitle"
                          stickyHeader
                          size='small'
                      >
                          <EnhancedTableHead
                              numSelected={selected.length}
                              order={order}
                              orderBy={orderBy}
                              onSelectAllClick={handleSelectAllClick}
                              onRequestSort={handleRequestSort}
                              rowCount={therapistNotesDataRes && therapistNotesMainData?.length}
                          />
                          <TableBody>
                              {
                                  (therapistNotesMainData || [])
                                      .map((row, index) => {
                                          const labelId = `enhanced-table-checkbox-${index}`;
                                          return (
                                              <React.Fragment key={index}>
                                                  <TableRow hover onClick={(event) => handleClick(event, row.title)} role="checkbox"
                                                      tabIndex={-1}
                                                      key={index}
                                                      >
                                                      <TableCell className="fw-bold" size="small" align="left" sx={{verticalAlign: 'top'}}>
                                                          { row.first_name +" "+ row.last_name || '-'}
                                                          </TableCell>

                                                          <TableCell sx={{verticalAlign: 'top'}} align="left">
                                                          {row?.gender || '-'}
                                                          </TableCell>
                                                          
                                                          <TableCell sx={{verticalAlign: 'top'}} align="left">
                                                          {row?.room_no || '-'}
                                                          </TableCell>
                                                          
                                                          <TableCell sx={{verticalAlign: 'top'}} align="left">
                                                          {row?.assign_doctor || '-'}
                                                          </TableCell>
                                                          
                                                          <TableCell sx={{verticalAlign: 'top'}} align="left">
                                                          {row?.support_staff_name || '-'}
                                                          </TableCell>

                                                          <TableCell sx={{verticalAlign: 'top'}} align="left">
                                                          {row?.session_name || '-'}
                                                          </TableCell>

                                                          <TableCell sx={{verticalAlign: 'top'}} align="left">
                                                          {row?.therapist_room || '-'}
                                                          </TableCell>

                                                          <TableCell sx={{verticalAlign: 'top'}} align="left">
                                                          {row?.session_time ? moment(row?.session_time).format("MMM DD, YYYY hh:mm A") : '-'}
                                                          </TableCell>
                                                          
                                                          <TableCell sx={{verticalAlign: 'top'}} align="left">
                                                          {row?.session_notes ? <div dangerouslySetInnerHTML={{__html: row?.session_notes}}></div> : '-'}
                                                          </TableCell>
                                              
                                                          <TableCell sx={{verticalAlign: 'top'}} align="left">
                                                          {row?.notes_recommendation ? <div dangerouslySetInnerHTML={{__html: row?.notes_recommendation}}></div> : '-'}
                                                          </TableCell>
                                                  </TableRow>
                                              </React.Fragment>
                                          );
                                      })}
                          
                          </TableBody>
                      </Table>
                  </TableContainer>
                  : <div className='text-center w-100 text-muted mt-3'>No Records</div>}
              </>
          }
          </Paper>
          {
              !!therapistNotesMainData?.length
              &&
              <div className='paginationBlock'>
                  <div className='textData'><p>Items per page: </p></div>
                  <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                      <Select
                          placeholder={rowsPerPage}
                          className="react-select"
                          classNamePrefix="react-select"
                          value={rowsPerPage}
                          options={rowOptions}
                          isSearchable={false}
                          onChange={handleChangeRowsPerPage}
                          theme={(theme) => ({
                              ...theme,
                              colors: {
                                  ...theme.colors,
                                  primary25: '#F5F5F5',
                                  primary: '#74613C',
                              },
                          })}
                          menuPlacement="top"
                          menuPosition="fixed"
                          styles={{
                              menu: (base) => ({
                                  ...base,
                                  top: 'auto',
                                  bottom: 0,
                              }),
                          }}
                      />
                  </FormGroup>
                  {therapistNotesDataRes && <p className='endText'>   {therapistNotesDataRes?.start} - {therapistNotesDataRes?.end} of {therapistNotesDataRes?.total}</p>}
                  <p>                         
                    <button className={`btnPrev ${therapistNotesDataRes?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={therapistNotesDataRes?.current_page_no === 1} onClick={() => { handleChangePagePrev() }}>
                        <ArrowBackIosNewSharpIcon className='iconBtn' />
                    </button> 
                    <button className={`btnPrev ${therapistNotesDataRes?.current_page_no === therapistNotesDataRes?.total_pages ? "opacityBtns" : ''}`} disabled={therapistNotesDataRes?.current_page_no === therapistNotesDataRes?.total_pages} onClick={() => { handleChangePageNext() }}>
                        <ArrowForwardIosSharpIcon className='iconBtn' />
                    </button></p>
              </div>   
          }
      </Box>
    );
}
export default TherapistNotes;